import React from 'react';
import { Link } from 'react-router-dom';
import { company, contact, socials } from '../data/company';
import Logo from './Logo';
import Icon from './Icon';

const links = [
  ['Services', '/services'],
  ['Products', '/products'],
  ['Portfolio', '/portfolio'],
  ['About Us', '/about'],
  ['Career', '/career'],
  ['Contact', '/contact'],
];

export default function Footer() {
  return (
    <footer className="footer">
      <h2 className="footer__brand">{company.name}</h2>

      <nav className="footer__links" aria-label="Footer">
        {links.map(([label, to]) => (<Link key={to} to={to}>{label}</Link>))}
      </nav>

      <div className="footer__loc">
        <Icon name="pin" size={44} />
        <h3>Head Office</h3>
        <p>{contact.headOffice}</p>
        <p>Office: {contact.address}</p>
        <p>
          <a href={`tel:${contact.phone}`}>{contact.phone}</a> &nbsp;&middot;&nbsp; <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
      </div>

      <hr />

      <div className="footer__mid">
        <Logo light />
        <p>{company.description}</p>
        <div className="socials">
          {socials.map((s) => (
            s.url ? (
              <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.name}><Icon name={s.icon} size={18} /></a>
            ) : (
              <span key={s.name} aria-label={s.name} title={`${s.name} (link to be added)`}><Icon name={s.icon} size={18} /></span>
            )
          ))}
        </div>
      </div>

      <p className="footer__copy">
        &copy; {new Date().getFullYear()} <b>{company.name}</b>. All rights reserved. A {company.parent} company.
      </p>
    </footer>
  );
}
